import { Table } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { DataTable } from '../../components/DataTable';
import { PageHeader } from '../../components/PageHeader';
import { Title } from '../../components/Title';
import { useFilter } from '../../hooks/useFilter';
import { usePagination } from '../../hooks/usePagination';
import { queryWithFilter } from '../../util/api/queryWithFilter';
import { queryWithFilterAndPages } from '../../util/api/queryWithFilterAndPages';
import { SalesViewerTableRow } from './components/SalesViewerTableRow';
import type { ReceiptDto } from './types/ReceiptDto';
import { KeyedRow } from '../../components/KeyedRow';

export function SalesViewer() {
	const { organisation } = useParams();
	const filter = useFilter();
	const pagination = usePagination();

	const dailySalesQuery = queryWithFilterAndPages<ReceiptDto[]>(
		`${organisation}/sales-viewer/receipts`,
		filter.value,
		pagination.value,
	);

	const dailySalesCountQuery = queryWithFilter<number>(
		`${organisation}/sales-viewer/count`,
		filter.value,
	);

	return (
		<>
			<PageHeader title={'Sales Viewer'} filter={filter} />
			<DataTable
				pagination={pagination}
				totalItems={dailySalesCountQuery.data?.value ?? 100}
				isRowsLoading={dailySalesQuery.isLoading}
				isPaginationLoading={dailySalesCountQuery.isLoading}
				rows={pagination.value.pageSize}
			>
				<Table.Thead>
					<KeyedRow>
						<Table.Th>
							<Title label={'Identifier'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Date'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Time'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Branch'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Receipt Number'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Operator'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Gross Sale'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Total Amount'} />
						</Table.Th>
						<Table.Th>
							<Title label={'VAT'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Discount'} />
						</Table.Th>
						<Table.Th>
							<Title label={'Receipt'} />
						</Table.Th>
					</KeyedRow>
				</Table.Thead>
				<Table.Tbody>
					{dailySalesQuery.data?.value.map((element) => (
						<SalesViewerTableRow key={Math.floor(Math.random() * 100000000000000000)} receipt={element} />
					))}
				</Table.Tbody>
			</DataTable>
		</>
	);
}
